import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Tooltip } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import IconButton from 'components/IconButton';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import { useSwitch } from 'hooks/useSwitch';
import ProjectShareDialog from 'components/ProjectShareDialog';
import toolbarStyles from '../style.module.less';
const ShareButton = ({ selectedProjects, selectionEmpty, onSharingUpdated, }) => {
    const [open, onOpen, onClose] = useSwitch();
    const { session } = useSession();
    const canShare = session.login.hasClaim('projects:share');
    const handleSharingClosed = useCallback((updatedProjects) => {
        if (updatedProjects > 0) {
            onSharingUpdated();
        }
        onClose();
    }, [onClose, onSharingUpdated]);
    if (!canShare) {
        return null;
    }
    return (_jsxs("div", { children: [_jsx(Tooltip, { title: txt('share'), children: _jsx("div", { children: _jsx(IconButton, { disabled: selectionEmpty, onClick: onOpen, className: toolbarStyles.toolbarButton, id: "sharePP", children: _jsx(ShareAltOutlined, { className: toolbarStyles.toolbarButton }) }) }) }), _jsx(ProjectShareDialog, { projectsToShare: selectedProjects, onClose: handleSharingClosed, modalVisible: open })] }));
};
export default ShareButton;
